import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useAccordion } from 'site-modules/shared/components/inventory/accordion/use-accordion';
import { ViewMore } from 'site-modules/shared/components/inventory/view-more/view-more';

export const ViewMoreAccordionItem = memo(props => {
  const { id, children, ...rest } = props;
  const { openedItems, onToggleItem } = useAccordion();

  const handleToggle = useCallback(
    opened => {
      onToggleItem(id, opened);
    },
    [id, onToggleItem]
  );

  return (
    <ViewMore onToggle={handleToggle} open={openedItems.includes(id)} {...rest}>
      {children}
    </ViewMore>
  );
});

ViewMoreAccordionItem.propTypes = {
  id: PropTypes.string.isRequired,
};

ViewMoreAccordionItem.displayName = 'ViewMoreAccordionItem';
